class InvalidCredentialsError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.setPrototypeOf(this, InvalidCredentialsError.prototype);
  }
}

class PermissionsError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.setPrototypeOf(this, PermissionsError.prototype);
  }
}

class TimeoutError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}

export { InvalidCredentialsError, PermissionsError, TimeoutError };
